import {useCallback} from "react";
import {useUserPreferences} from "./UserPreferencesProvider";

export function useUserPrefString(key: string, defaultValue: string): [string, (value: string) => void] {
    const ctx = useUserPreferences();
    const raw = ctx.prefs[key];
    const value = raw === undefined ? defaultValue : raw;

    const setValue = useCallback((v: string) => ctx.set(key, v), [ctx, key]);

    return [value, setValue];
}

export function useUserPrefNumber(key: string, defaultValue: number): [number, (value: number) => void] {
    const ctx = useUserPreferences();
    const raw = ctx.prefs[key];
    const parsed = raw === undefined ? NaN : parseFloat(raw);
    const value = isNaN(parsed) ? defaultValue : parsed;

    const setValue = useCallback((v: number) => ctx.set(key, v.toString()), [ctx, key]);

    return [value, setValue];
}

export function useUserPrefClear() {
    const ctx = useUserPreferences();
    return ctx.clear;
}
